import request from './index'
import {toFormData} from '@/assets/utils';

//http://10.10.171.216:9001/api/browser?numbercount=1  
export function getBrowser (params) {
    return request({
        url: "/browser",
        method: "GET",
        params
    })
}

export function getBrowseContent (params) {
    return request({
        url: "/browser/content",
        method: "GET",
        params
    })
}

export function getSameLigands (params) {
    return request({
        url: "/browser/sameLigand",
        method: "GET",
        params
    })
}

//相似序列的列表
export function getProteinSequenceSimilarity (params) {
    return request({
        url: "/browser/proteinSequenceSimilarity",
        method: "GET",
        params
    })
}

//反馈
export function feedback (data) {
    return request({
        url: "/feedback",
        method: "POST",
        data: toFormData(data)
    })
}

// 显示蛋白序列
export function showFastaFile (pdbcode) {
    return request({
        url: "/browser/fasta/" + pdbcode +".txt",
        method: "GET"
    })
}

// contact us

export function getContactus (data) {
    return request({
        url: "/contactus",
        method: "POST",
        data
    })
}